import { useCallback } from 'react'
import { useDispatch } from 'react-redux'
import { AppErrorType, ErrorPageContentOptions, ErrorPageCtaOptions, ErrorPageState } from '@typesApp/AppError'
import { ROUTES } from '@constants/index'
import { useAppNavigate } from '@hooks/useAppNavigate'
import { usePathBuilder } from '@hooks/usePathBuilder'
import { resetAppError, resetDrawerHeader, setAppError } from '@redux/slices/workflowSlice'

type ErrorPageOptions = {
  errorType?: AppErrorType
  ctaOptions?: ErrorPageCtaOptions
  contentOptions?: ErrorPageContentOptions
}

type UseErrorPageReturn = {
  showErrorPage: (options?: ErrorPageOptions) => void
}

export const useErrorPage = (): UseErrorPageReturn => {
  const dispatch = useDispatch()
  const navigate = useAppNavigate()
  const buildPath = usePathBuilder()

  const showErrorPage = useCallback(
    (options?: ErrorPageOptions) => {
      const { errorType, ctaOptions, contentOptions } = options ?? {}

      // NOTE: we cannot serialize callbacks in the navigate state so need to use redux
      if (!ctaOptions?.ctaOnClick && (!ctaOptions?.customActions || ctaOptions.customActions.length === 0)) {
        if (errorType) {
          dispatch(setAppError({ errorType }))
        } else {
          dispatch(resetAppError())
        }
      } else {
        dispatch(
          setAppError({
            errorType,
            ctaCallback: ctaOptions.ctaOnClick,
            customActions: ctaOptions.customActions,
          })
        )
      }

      const state: ErrorPageState = {
        errorType,
        title: contentOptions?.title,
        message: contentOptions?.message,
        ctaLabel: ctaOptions?.ctaLabel,
      }

      dispatch(resetDrawerHeader())
      navigate(buildPath(ROUTES.ERROR), { state })
    },
    [dispatch, navigate, buildPath]
  )

  return {
    showErrorPage,
  }
}
